var exports = {
  "k": "x0a7806d5--9744b6--container",
};

module.exports = exports;
